import React from "react";
import StepContainer from "../StepContainer";
import TemplatePanel from "./TemplatePanel";
import { useCampaignPageView } from "../CampaignPage.context";
import ComponentLoader from "../../../../customComponents/ComponentLoader/ComponentLoader";
import { Box, Container } from "@mui/material";
import { Stripo } from "@tiny/stripo-editor";
import { useConfigView } from "../../../../Config.context";
import { useGetCustomAttributeMergeTagsQuery } from "../../../../app/useGeneratedApi";

function DesignStep() {
  const {
    handleTemplateChange,
    handleTemplateLoaded,
    handleTemplateUnLoaded,
    hideTemplateHistory,
    selectTemplate,
    stripoRef,
    templateCss,
    templateEditing,
    templateHtml,
    templateEditorType,
    templateHistoryVisible,
    screenLoading,
    setScreenLoading,
    id: templateId,
  } = useCampaignPageView();

  const { config } = useConfigView();
  const { appName } = config || {};

  // Stripo only reads mergeTags once, at init, so hold the editor back until
  // the custom attribute tags have resolved - otherwise they are missing from
  // the merge tag picker for the whole session.
  const { data: mergeTagsData, isFetched: mergeTagsFetched } =
    useGetCustomAttributeMergeTagsQuery();
  const customMergeTags = mergeTagsData?.customAttributeMergeTags;

  React.useEffect(() => {
    if (templateEditing) {
      setScreenLoading(true);
    }
  }, [templateEditing]);

  if (templateEditing) {
    const codeEditorVisible = templateEditorType === "HTML";
    const settingsVisible = templateEditorType !== "HTML";

    return (
      <Container
        sx={(theme) => ({
          minWidth: "100vw",
          minHeight: "100%",
          position: "relative",
        })}
        disableGutters
      >
        {(screenLoading || !mergeTagsFetched) && (
          <Box
            sx={{
              position: "absolute",
              top: "0",
              bottom: "0",
              left: "0",
              right: "0",
              zIndex: 1000,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "rgba(0,0,0,0.5)",
            }}
          >
            <ComponentLoader loading={screenLoading || !mergeTagsFetched} />
          </Box>
        )}
        {mergeTagsFetched && (
          <Stripo
            codeEditorVisible={codeEditorVisible}
            css={templateCss ?? ""}
            customMergeTags={customMergeTags}
            emailId={templateId ?? ""}
            historyVisible={templateHistoryVisible}
            html={templateHtml ?? ""}
            onTemplateChange={handleTemplateChange}
            onTemplateLoaded={() => {
              handleTemplateLoaded();
            }}
            onTemplateUnloaded={handleTemplateUnLoaded}
            onHistoryHide={hideTemplateHistory}
            ref={stripoRef}
            settingsVisible={settingsVisible}
          />
        )}
      </Container>
    );
  }

  return (
    <StepContainer>
      <TemplatePanel selectTemplate={selectTemplate} />
    </StepContainer>
  );
}

export default DesignStep;
